import React from 'react';

const Logo = ({ className = "", showText = true, size = "default", variant = "full" }) => {
  const sizes = {
    small: { height: 40 },
    default: { height: 56 },
    large: { height: 80 },
    hero: { height: 120 }
  };
  
  const { height } = sizes[size] || sizes.default;

  // Use the logo from local assets
  const logoUrl = "/assets/interware-logo.png";

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={logoUrl}
        alt="Interware - Beyond AI"
        style={{ height: `${height}px`, width: 'auto' }}
        className="object-contain"
      />
    </div>
  );
};

export default Logo;
